import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from "react";
import Telescope from "@hl/base-components/lib/assets/icons.generated/HDS/Duotone icons/Education/Telescope";
import Check from "@hl/base-components/lib/assets/icons.generated/HDS/Duotone icons/General/Check";
import useMantineMediaQueries from "@hl/base-components/lib/hooks/useMantineMediaQueries";
import { Button, Group } from "@mantine/core";
import { toStandardCollectionId } from "../../../utils/blockchain";
import { useAuth } from "../../auth";
import { FEATURE_FLAGS, useFeatureFlags } from "../../auth/hooks";
import { useWatchlist } from "./useWatchlist";
export const WatchlistButton = (props) => {
    const auth = useAuth();
    const enableFollows = useFeatureFlags(FEATURE_FLAGS.ENABLE_FOLLOWS);
    if (!auth.authenticated || !enableFollows) {
        return null;
    }
    return _jsx(WatchlistButtonInner, { ...props });
};
const WatchlistButtonInner = (props) => {
    const { onchainId, ...rest } = props;
    const { loading, isWatching, watch } = useWatchlist();
    const { isExtraSmall } = useMantineMediaQueries();
    const standarizedOnchainId = useMemo(() => toStandardCollectionId(onchainId), [onchainId]);
    const watching = useMemo(() => {
        if (standarizedOnchainId == null)
            return false;
        return isWatching(standarizedOnchainId);
    }, [isWatching, standarizedOnchainId]);
    if (standarizedOnchainId == null || loading)
        return null;
    return (_jsx(Button, { size: "xs", color: watching ? "secondaryButton" : "primaryButton", pl: !isExtraSmall ? 8 : undefined, onClick: async () => {
            await watch(standarizedOnchainId, !watching);
        }, ...rest, children: _jsxs(Group, { noWrap: true, spacing: 2, children: [watching ? _jsx(Check, { height: 16 }) : _jsx(Telescope, { height: 16 }), _jsx("span", { children: watching ? "Watching" : "Watch" })] }) }));
};
